import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { ApplicationType } from './application-types.interface';
export class ApplicationTypeService {
   async getApplicationTypes() {
      const response = await http.get<ApiResource<Array<ApplicationType>>>('/application-types', { ...cacheFirstConfig });
      return response.data;
   }

   async getApplicationType() {
      throw Error('Method not implemented');
   }

   async postApplicationType() {
      throw Error('Method not implemented');
   }

   async putApplicationType() {
      throw Error('Method not implemented');
   }

   async deleteApplicationType() {
      throw Error('Method not implemented');
   }
}
